"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEquivalent = exports.omitByDeep = exports.getOneOf = void 0;
const { get, map, omitBy, isEmpty, xor } = require('lodash');
const getOneOf = (targetArg, pathArg, defValue) => {
    const targets = Array.isArray(targetArg) ? targetArg : [targetArg];
    const paths = Array.isArray(pathArg) ? pathArg : [pathArg];
    const pairs = [];
    targets.forEach((target) => {
        paths.forEach((path) => {
            pairs.push({
                target,
                path,
            });
        });
    });
    const reduced = pairs.reduce((ret, { target, path }) => {
        return ret !== undefined ? ret : get(target, path);
    }, undefined);
    return reduced !== undefined ? reduced : defValue;
};
exports.getOneOf = getOneOf;
const omitByDeep = (object, predicate) => {
    const deep = map(object, (value) => {
        if (Array.isArray(value))
            return value;
        if (typeof value === 'object')
            return (0, exports.omitByDeep)(value, predicate);
        return value;
    });
    return omitBy(object, predicate);
};
exports.omitByDeep = omitByDeep;
const isEquivalent = (array1, array2) => {
    return isEmpty(xor(array1, array2));
};
exports.isEquivalent = isEquivalent;
